import React, { useState, useEffect, useRef } from "react";
import "./skills.css";
import { Button, Modal, Card, Container, Row, Col, Badge, Spinner, Pagination } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FiGithub, FiExternalLink, FiInfo, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import api1 from "../Images/api1.png";
import api2 from "../Images/api2.png";
import api3 from "../Images/api3.png";
import api4 from "../Images/api4.png";
import api5 from "../Images/api5.png";
import api6 from "../Images/api6.jpg";

function Skills() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [selectedProject, setSelectedProject] = useState({});
  const [repos, setRepos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Estados de Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  const githubSectionRef = useRef(null);

  const handleClose = () => setShow(false);
  const handleShow = (project) => {
    setSelectedProject(project);
    setShow(true);
  }

  const handleLink = (url) => {
    window.open(url, '_blank');
  }

  const projects = [
    { id: 1, title: t('api-1-title'), imgSrc: api1, description: t('api-1-description'), githubLink: "https://github.com/EquipeGfour/API-GFour-Primeiro-Semestre-" },
    { id: 2, title: t('api-2-title'), imgSrc: api2, description: t('api-2-description'), githubLink: "https://github.com/EquipeGfour/Api-2-Semestre-" },
    { id: 3, title: t('api-3-title'), imgSrc: api3, description: t('api-3-description'), githubLink: "https://github.com/EquipeGfour/API-3Semestre-UOL" },
    { id: 4, title: t('api-4-title'), imgSrc: api4, description: t('api-4-description'), githubLink: "https://github.com/EquipeGfour/API-4SemestreDSM-EstacaoMeteorologica" },
    { id: 5, title: t('api-5-title'), imgSrc: api5, description: t('api-5-description'), githubLink: "https://github.com/EquipeGfour/API-5Semestre-OracleAcademy" },
    { id: 6, title: t('api-6-title'), imgSrc: api6, description: t('api-6-description'), githubLink: "https://github.com/EquipeGfour/API-6-Semestre-Dom-Rock" }
  ];

  useEffect(() => {
    const fetchRepos = async () => {
      try {
        const username = 'rodrigoribeiro027';
        // Buscamos 100 para garantir material para paginação
        const response = await fetch(`https://api.github.com/users/${username}/repos?sort=updated&per_page=100`);
        if (!response.ok) throw new Error('Falha ao carregar repositórios');
        const data = await response.json();
        
        // Deduplicação absoluta por ID
        const uniqueRepos = Array.from(new Map(data.map(repo => [repo.id, repo])).values());
        
        setRepos(uniqueRepos);
        setLoading(false);
      } catch (err) {
        console.error('Erro:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchRepos();
  }, []);

  // Lógica de Paginação
  const lastIndex = currentPage * itemsPerPage;
  const firstIndex = lastIndex - itemsPerPage;
  const currentRepos = repos.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(repos.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    // Scroll suave para o início da seção
    if (githubSectionRef.current) {
      githubSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Container fluid className="projects-section py-5">
      {/* Modal de Detalhes */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{selectedProject.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img src={selectedProject.imgSrc} alt={selectedProject.title} className="img-fluid rounded mb-3 shadow" />
          <h5 className="text-secondary mb-3">{t('detalhes')}</h5>
          <p className="project-description">{selectedProject.description}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={handleClose}>
            {t('fechar')}
          </Button>
          <Button variant="primary" onClick={() => handleLink(selectedProject.githubLink)}>
            <FiGithub className="me-2" /> GitHub
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Projetos Integrados (API) */}
      <h2 className="section-title mb-5">{t('api')}</h2>
      <Row className="g-4 mb-5 justify-content-center">
        {projects.map((project) => (
          <Col key={project.id} xs={12} md={6} lg={4}>
            <Card className="project-card h-100 border-0 shadow-sm">
              <div className="card-img-container">
                <Card.Img variant="top" src={project.imgSrc} alt={project.title} />
                <div className="card-overlay">
                  <Button variant="light" size="sm" onClick={() => handleShow(project)}>
                    <FiInfo className="me-1" /> {t('detalhes')}
                  </Button>
                </div>
              </div>
              <Card.Body>
                <Card.Title className="h6 text-truncate-2" title={project.title}>{project.title}</Card.Title>
                <div className="mt-auto d-flex justify-content-between align-items-center">
                  <Badge bg="success" className="bg-opacity-10 text-success border border-success border-opacity-25 py-2">
                    Fatec Project
                  </Badge>
                  <Button variant="link" className="p-0 text-dark" onClick={() => handleLink(project.githubLink)}>
                    <FiGithub size={20} />
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Seção GitHub com Ref para Scroll */}
      <div ref={githubSectionRef} className="scroll-anchor" style={{ position: 'relative', top: '-100px' }}></div>
      <h2 className="section-title mb-5 mt-5">{t('Outrosprojetos')}</h2>
      
      <Container className="github-repos-section p-4 rounded-4 shadow-sm bg-light">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
          <h3 className="h5 mb-3 mb-md-0 text-dark"><FiGithub className="me-2" />{t('meusRepositorios')}</h3>
          {!loading && !error && repos.length > 0 && (
            <span className="text-muted small">
              Mostrando {firstIndex + 1}–{Math.min(lastIndex, repos.length)} de {repos.length} projetos
            </span>
          )}
        </div>
        
        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="success" />
          </div>
        ) : error ? (
          <div className="text-center text-danger py-4">{error}</div>
        ) : (
          <>
            <Row className="g-3">
              {currentRepos.map((repo) => (
                <Col key={repo.id} xs={12} sm={6} md={4}>
                  <Card className="repo-card h-100 border-0">
                    <Card.Body className="d-flex flex-column p-3">
                      <Card.Title className="h6 mb-2 text-truncate" title={repo.name}>{repo.name}</Card.Title>
                      <Card.Text className="small text-muted text-truncate-2 mb-3">
                        {repo.description || "No description provided."}
                      </Card.Text>
                      <div className="mt-auto d-flex gap-2">
                        <Button 
                          variant="outline-success" 
                          size="sm" 
                          className="flex-grow-1 rounded-pill"
                          onClick={() => handleLink(repo.html_url)}
                        >
                          <FiGithub className="me-1" /> Repo
                        </Button>
                        {repo.homepage && (
                          <Button 
                            variant="success" 
                            size="sm" 
                            className="flex-grow-1 rounded-pill"
                            onClick={() => handleLink(repo.homepage)}
                          >
                            <FiExternalLink className="me-1" /> Demo
                          </Button>
                        )}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* Sistema de Paginação */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-5">
                <Pagination className="custom-pagination">
                  <Pagination.Prev 
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <FiChevronLeft />
                  </Pagination.Prev>
                  
                  {[...Array(totalPages)].map((_, idx) => (
                    <Pagination.Item
                      key={idx + 1}
                      active={idx + 1 === currentPage}
                      onClick={() => handlePageChange(idx + 1)}
                    >
                      {idx + 1}
                    </Pagination.Item>
                  ))}

                  <Pagination.Next 
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <FiChevronRight />
                  </Pagination.Next>
                </Pagination>
              </div>
            )}
          </>
        )}
      </Container>
    </Container>
  );
}

export default Skills;
